import { AppRoutes } from '@/constants';
import { AuthAction, Module, SubModule } from '@/enums';

import { Mail01Icon, User02Icon } from '@/assets/icons';

import { INavItem } from './FloatingNavBar.interfaces';

export const NAV_ITEMS: INavItem[] = [
  {
    id: AppRoutes.INTAKE_JOBS,
    label: 'Regulatory Intake',
    icon: Mail01Icon,
    module: Module.RegulatoryIntake,
    subModule: SubModule.RegulatoryIntake,
    action: AuthAction.Read,
  },
  {
    id: AppRoutes.USER_MANAGEMENT,
    label: 'User Management',
    icon: User02Icon,
    module: Module.UserManagement,
    subModule: SubModule.UserManagement,
    action: AuthAction.Read,
  },
];
